import {
	ONLINE_INQUIRY_GET_SETTLEMENTS_URL,
	ONLINE_INQUIRY_GET_STREETS_URL,
	ONLINE_INQUIRY_GET_HOUSE_NUMBERS_URL,
	ONLINE_INQUIRY_SEARCH_URL,
} from './urls'

export const getSettlements = () => axios.get(ONLINE_INQUIRY_GET_SETTLEMENTS_URL)
export const getHouseNumbers = (streetId) => axios.get(`${ONLINE_INQUIRY_GET_HOUSE_NUMBERS_URL}/${streetId}`)
export const getStreets = (settlement) => axios.get(`${ONLINE_INQUIRY_GET_STREETS_URL}/${settlement}`)
export const getSearchResults = (params) => axios.get(ONLINE_INQUIRY_SEARCH_URL, {params})



// WEBPACK FOOTER //
// ../source/common/api/online-inquiry.api.js